/** Backend uses `draft` | `published`. Missing/legacy → treat as published (live). */

export function isBlogPublished(blog) {
    return blog?.status !== "draft";
}

export function blogStatusLabel(blog) {
    return isBlogPublished(blog) ? "Published" : "Draft";
}
